import "../Css/Navbar.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UseTicket, SetTicket } from "../Js/Context/TicketCntx";

export default function Navbar(props) {
  const { setNavbarItemChoosed } = props;
  const navigate = useNavigate();
  const ticket = UseTicket();
  const setTicket = SetTicket();

  useEffect(() => {
    setNavbarItemChoosed(ticket.ContractSide || "tickets");
  }, []);
  const onChangeNavigation = () => {
    navigate(`${process.env.PUBLIC_URL}/FrontPage`);
  };
  const onChangeNavbarItem = (contractSide) => {
    setTicket((prevState) => ({
      ...prevState,
      ContractSide: contractSide,
    }));
    setNavbarItemChoosed(contractSide);
  };
  return (
    <div className="Navbar-box">
      <div id="navbar" className="flexRow">
        <div
          onClick={() => {
            onChangeNavbarItem("dashboard");
          }}
          className={`${
            ticket.ContractSide == "dashboard" ? "is-clicked" : "not-clicked"
          }`}
        >
          <img></img>
          <p>دشبورد</p>
        </div>
        {localStorage.getItem("Role") == "1" ? (
          <div
            onClick={() => {
              onChangeNavbarItem("organization");
            }}
            className={`${
              ticket.ContractSide == "organization"
                ? "is-clicked"
                : "not-clicked"
            }`}
          >
            <img></img>
            <p>سازمان</p>
          </div>
        ) : (
          ""
        )}

        {localStorage.getItem("Role") == "1" ? (
          <div
            onClick={() => {
              onChangeNavbarItem("customers");
            }}
            className={`${
              ticket.ContractSide == "customers" ? "is-clicked" : "not-clicked"
            }`}
          >
            <img></img>
            <p>مشتریان</p>
          </div>
        ) : (
          ""
        )}
        <div
          onClick={() => {
            onChangeNavigation();
            onChangeNavbarItem("tickets");
          }}
          className={`${
            ticket.ContractSide == "tickets" ? "is-clicked" : "not-clicked"
          }`}
        >
          <img></img>
          <p>تیکت ها</p>
        </div>

        {/*<div*/}
        {/*    onClick={() => {*/}
        {/*        onChangeNavbarItem("knowledgeBase");*/}
        {/*    }}*/}
        {/*    className={`${states.ContractSide == "knowledgeBase"*/}
        {/*        ? "is-clicked"*/}
        {/*        : "not-clicked"*/}
        {/*        }`}*/}
        {/*>*/}
        {/*    <img></img>*/}
        {/*    <p>پایگاه دانش</p>*/}
        {/*</div>*/}
        {/*<div*/}
        {/*    onClick={() => {*/}
        {/*        onChangeNavbarItem("repors");*/}
        {/*    }}*/}
        {/*    className={`${states.ContractSide == "repors"*/}
        {/*        ? "is-clicked"*/}
        {/*        : "not-clicked"*/}
        {/*        }`}*/}
        {/*>*/}
        {/*    <img></img>*/}
        {/*    <p>گزارشات</p>*/}
        {/*</div>*/}
        {/*<div*/}
        {/*    onClick={() => {*/}
        {/*        onChangeNavbarItem("setting");*/}
        {/*    }}*/}
        {/*    className={`${states.ContractSide == "setting"*/}
        {/*        ? "is-clicked"*/}
        {/*        : "not-clicked"*/}
        {/*        }`}*/}
        {/*>*/}
        {/*    <img></img>*/}
        {/*    <p>تنظیمات</p>*/}
        {/*</div>*/}
        <div
          onClick={() => {
            onChangeNavbarItem("exit");
          }}
          className={`${
            ticket.ContractSide == "exit" ? "is-clicked" : "not-clicked"
          }`}
        >
          <img></img>
          <p>خروج</p>
        </div>
      </div>

      <div className="userInfo">
        <p>
          <span>نام کاربری : </span>
          <span>{localStorage.getItem("Name")}</span>
        </p>
      </div>
    </div>
  );
}
